module.exports = __webpack_public_path__ + "img/CriticalDiameterDetails-min.60423d6f.png";